import React, { useState } from 'react';
import { DoctoralAchievement } from '../types';
import { Card, Hero, Kpis } from './dp120Parts';

interface DoctoralAchievementsViewProps {
  achievements?: DoctoralAchievement[];
  onAddAchievement?: (item: DoctoralAchievement) => void;
}

const GROUPS: [string, string, string][] = [
  ['LANGUAGE', 'Языковые сертификаты', 'IELTS / TOEFL / КАЗТЕСТ и иные сертификаты'],
  ['COURSE', 'Повышение квалификации и курсы', 'Курсы, школы и программы профессионального развития'],
  ['AWARD', 'Награды и академические достижения', 'Дипломы, конкурсы и научные школы'],
  ['PROJECT', 'Профессиональные подтверждения', 'Проекты, тестирование и иные подтверждения'],
];

export const DoctoralAchievementsView: React.FC<DoctoralAchievementsViewProps> = ({
  achievements = [],
  onAddAchievement,
}) => {
  const [title, setTitle] = useState('');
  const [kind, setKind] = useState('LANGUAGE');
  const [issuer, setIssuer] = useState('');
  const [notice, setNotice] = useState('');

  const count = (value: string) => achievements.filter((item) => item.kind === value).length;

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!title.trim() || !onAddAchievement) return;
    onAddAchievement({
      kind,
      title: title.trim(),
      issuer: issuer.trim(),
      date_label: new Date().toLocaleDateString('ru-RU'),
    });
    setTitle('');
    setIssuer('');
    setNotice('Достижение отправлено на сохранение.');
  };

  return (
    <>
      <Hero
        kicker="PERSONAL PORTFOLIO"
        title="Достижения и сертификаты"
        text="Портфолио результатов, которые важны для академической траектории, но не являются НИРД, публикацией или документом практики."
        color="#f1b93f"
      />
      {notice ? <div className="dp120-callout" style={{ marginTop: 10 }}><b>{notice}</b></div> : null}
      <Kpis
        items={[
          ['Иностранный язык', String(count('LANGUAGE')), 'Сертификаты'],
          ['Курсы', String(count('COURSE')), 'Повышение квалификации'],
          ['Награды', String(count('AWARD')), 'Дипломы / конкурсы'],
          ['Другие', String(count('PROJECT')), 'Подтверждающие материалы'],
        ]}
      />
      <div className="dp120-grid">
        {GROUPS.map(([value, heading, note]) => {
          const rows = achievements.filter((item) => item.kind === value);
          return (
            <Card key={value} title={heading} sub={note}>
              <div className="dp120-list">
                {rows.length === 0 && <div className="dp120-empty">Пока нет записей.</div>}
                {rows.map((item) => (
                  <div key={item.id || item.title} className="dp120-row">
                    <span>
                      <strong>{item.title}</strong>
                      <small>
                        {[item.issuer, item.date_label, item.score_label].filter(Boolean).join(' · ')}
                      </small>
                    </span>
                    {item.file_url ? <span className="dp120-filetag">{item.file_url}</span> : null}
                  </div>
                ))}
              </div>
            </Card>
          );
        })}
        <Card title="Добавить подтверждение" sub="Запись сохраняется в портфолио докторанта." span="span12">
          <form className="dp120-form" onSubmit={submit}>
            <label className="dp120-field">
              <span>Вид</span>
              <select value={kind} onChange={(e) => setKind(e.target.value)}>
                {GROUPS.map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </label>
            <FieldLike label="Название" value={title} onChange={setTitle} />
            <FieldLike label="Кто выдал" value={issuer} onChange={setIssuer} />
            <div className="dp120-course-actions">
              <button type="submit" className="dp120-btn gold">
                Сохранить портфолио
              </button>
            </div>
          </form>
        </Card>
      </div>
    </>
  );
};

function FieldLike({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <label className="dp120-field">
      <span>{label}</span>
      <input value={value} onChange={(e) => onChange(e.target.value)} />
    </label>
  );
}
